import { getLocalTranslation } from '../../utils/i18nKit';
export var getRecruitmentBusinessActivityList = function getRecruitmentBusinessActivityList() {
  var _getLocalTranslation = getLocalTranslation(),
      $t = _getLocalTranslation.$t;

  return [{
    value: 'BCS-224',
    label: $t('text:recruitment.agency_temp_permanent')
  }, {
    value: 'BCS-225',
    label: $t('text:recruitment.agency_with_payroll')
  }];
};